import ExpoLocation from './ExpoLocation';

export const LocationEventEmitter = ExpoLocation;
